import { cn } from "@/lib/utils";

type StatusBadgeProps = {
  status: string;
  size?: "sm" | "md";
};

function getStatusClasses(status: string): string {
  const normalized = status.toLowerCase().replace(/\s+/g, "_");

  switch (normalized) {
    case "active":
    case "approved":
    case "completed":
    case "valid":
      return "bg-green-100 text-green-800";

    case "pending":
    case "trialling":
    case "trialing":
      return "bg-amber-100 text-amber-800";

    case "suspended":
    case "cancelled":
    case "canceled":
    case "blocked":
    case "rejected":
    case "over_limit":
    case "revoked":
      return "bg-red-100 text-red-800";

    case "inactive":
    case "expired":
    case "not_required":
      return "bg-gray-100 text-gray-600";

    case "past_due":
      return "bg-orange-100 text-orange-800";

    default:
      return "bg-gray-100 text-gray-600";
  }
}

function formatStatus(status: string): string {
  return status
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function StatusBadge({ status, size = "md" }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center font-medium rounded-full",
        size === "sm" ? "px-2 py-0.5 text-xs" : "px-2.5 py-0.5 text-sm",
        getStatusClasses(status),
      )}
    >
      {formatStatus(status)}
    </span>
  );
}
